/* Product reviews (Growave), ADG presentation, 2026-10-12.
   1. An ADG section heading ("Customer Reviews", same style as "About the Art")
      above each Growave review widget; Growave's own smaller title is hidden.
   2. Inside the widget (open shadow root): ADG buttons (ink, orange hover) and a
      compact empty state instead of Growave's 328px grey box with illustration.
   Growave attaches its shadow root after load, so this checks for a few seconds
   and re-applies if Growave re-renders. */
(() => {
  const STYLE = `
    .gw-rv-product-page-widget > p.gw-text--heading-lg { display: none !important; }
    .gw-btn--mode-primary { background: #231F20 !important; border-radius: 10px !important; padding: 10px 18px !important; transition: background-color .15s ease; }
    .gw-btn--mode-primary:hover, .gw-btn--mode-primary:focus-visible { background: #FF4A06 !important; }
    .gw-rv-reviews-list-widget__empty-list-wrapper { padding: 0 !important; }
    .gw-empty-state { height: auto !important; background: transparent !important; padding: 4px 0 0 !important;
      flex-direction: row !important; flex-wrap: wrap !important; align-items: center !important;
      justify-content: flex-start !important; text-align: left !important; gap: 16px !important; }
    .gw-empty-state > svg { display: none !important; }
  `;
  function addHeading(ph) {
    const prev = ph.previousElementSibling;
    if (prev && prev.classList.contains('adg-reviews-title')) return;
    const h = document.createElement('h2');
    h.className = 'adg-reviews-title';
    h.id = 'reviews';
    h.textContent = 'Customer Reviews';
    ph.before(h);
  }
  function addStyle(ph) {
    const sr = ph.shadowRoot;
    if (!sr || sr.querySelector('style[data-adg-reviews]')) return;
    const s = document.createElement('style');
    s.setAttribute('data-adg-reviews', '');
    s.textContent = STYLE;
    sr.appendChild(s);
    if (!ph.__adgMO) {
      ph.__adgMO = new MutationObserver(() => { if (!sr.querySelector('style[data-adg-reviews]')) addStyle(ph); });
      ph.__adgMO.observe(sr, { childList: true });
    }
  }
  // The star line under the title says "No reviews" when there are none; hide it then.
  function checkStars() {
    document.querySelectorAll('.adg-review-stars').forEach((wrap) => {
      const ph = wrap.querySelector('.gw-rv-star-rating-widget-placeholder');
      const txt = ph && ph.shadowRoot ? ph.shadowRoot.textContent : '';
      if (!txt) return;
      if (/no reviews/i.test(txt)) wrap.setAttribute('data-empty', ''); else wrap.removeAttribute('data-empty');
    });
  }
  function run() {
    document.querySelectorAll('.gw-rv-main-widget-placeholder').forEach((ph) => { addHeading(ph); addStyle(ph); });
    checkStars();
  }
  run();
  document.addEventListener('DOMContentLoaded', run);
  let n = 0;
  const t = setInterval(() => { run(); if (++n > 40) clearInterval(t); }, 250);
})();
